import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ConfigurationCommitmentsService } from './configuration-commitments.service';
import { ConfigurationCommitmentsTab1Part } from './tabs/tab-1/configuration-commitments-tab-1.part';
import { ConfigurationCommitmentsTab2Part } from './tabs/tab-2/configuration-commitments-tab-2.part';
import { ConfigurationCommitmentsViewsPart } from './views/commitments-views.part';
@Component({
	selector: 'configuration-commitments-page',
	standalone: true,
	imports: [
		ConfigurationCommitmentsTab1Part,
		ConfigurationCommitmentsTab2Part,
		ConfigurationCommitmentsViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		DroplistWidget,
		ToolbarWidget,
		TrimesterDroplistWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './configuration-commitments.page.html',
})
export class ConfigurationCommitmentsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	constructor(public pageService: ConfigurationCommitmentsService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}